

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.$windowsContainer = $el.find('.-content-windows');
        this.tabs = [];
        this.current = null;
        this.conf = $el.data('tabs');
        this.isMobile = null;
        $el.find('[data-tab-trig]').each((i, el)=>{
            let tab = new DcodeTab($(el), this);
            this.tabs.push(tab);
            if (tab.$window.hasClass('-current')) {
                this.current = tab;
            }
        });
        if (this.current === null) {
            this.current = this.tabs[0];
            this.current.show();
        }
        windowPal.resize(()=>{
            this.updateLayout();
        });
        this.updateLayout();
    }
    updateLayout() {
        let windowWidth = this.windowPal.$.width();
        if (windowWidth > this.conf.breakpoint) {
            // console.log('setAsDesktop');
            if (this.isMobile !== false) {
                this.isMobile = false;
                this.setAsDesktop();
            }
        } else {
            // console.log('setAsMobile');
            if (this.isMobile !== true) {
                this.isMobile = true;
                this.setAsMobile();
            }
        }
    }
    setAsDesktop() {
        this.tabs.forEach((tab, i)=>{
            // console.log(tab.$window[0], tab.$trig[0]);
            this.$windowsContainer.append(tab.$window);
        });
    }
    setAsMobile() {
        this.tabs.forEach((tab, i)=>{
            // console.log(tab.$window[0], tab.$trig[0]);
            tab.$window.insertAfter(tab.$trig);
        });
    }
    show(tab) {
        this.hideCurrent();
        this.current = tab;
    }
    hideCurrent() {
        if (this.current !== null) {
            this.current.hide();
            this.current = null;
        }
    }
}



class DcodeTab {
    constructor($trig, master) {
        this.$trig = $trig;
        this.master = master;
        this.id = $trig.data('tab-trig');
        this.link = $trig.data('link');
        // console.log('this.link', this.link);
        this.$window = master.$windowsContainer.find('.-window-'+this.id);
        $trig.click(()=>{
            this.click();
        });
    }
    click() {
        if (this.link) {
            console.log('go to link ' + this.link);
            window.location = this.link;
        } else {
            if (this.master.current === this) {
                this.master.hideCurrent();
            } else {
                this.master.show(this);
                this.show();
            }
        }
    }
    show() {
        this.$window.addClass('-current');
        this.$trig.addClass('-current');
    }
    hide() {
        this.$window.removeClass('-current');
        this.$trig.removeClass('-current');
    }
}




// WEBPACK FOOTER //
// ./scripts/lib/DcodeTabs.js